var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", { class: { opened: _vm.opened } }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "user" }, [
        _vm.user.profile
          ? _c("img", {
              attrs: { src: _vm.user.profile.profile_picture, alt: "" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("div", [_vm._v("Bem-vindo(a),")]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n          " + _vm._s(_vm.user.first_name) + "\n          "
            ),
            _c("div", { staticClass: "dropdown" }, [
              _c("img", {
                attrs: {
                  src: "/static/arrow-down.svg",
                  height: "10px",
                  alt: "Opções"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-content" }, [
                _c("ul", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.logout } }, [
                    _c("img", { attrs: { src: "/static/logout.svg" } }),
                    _vm._v(" sair")
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("ul", [
        _c(
          "li",
          { class: { active: ["dashboard"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/dashboard" } }, [
              _c("img", { attrs: { src: "/static/menu-dashboard.svg" } }),
              _vm._v(" DASHBOARD\n        ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { class: { active: ["notifications"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/notificacoes" } }, [
              _c("img", { attrs: { src: "/static/menu-notifications.svg" } }),
              _vm._v(" NOTIFICAÇÕES\n        ")
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("USUÁRIOS")]),
      _vm._v(" "),
      _c("ul", [
        _c(
          "li",
          { class: { active: ["donamakers"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/donamakers" } }, [
              _c("img", { attrs: { src: "/static/menu-donamakers.svg" } }),
              _vm._v(" DONAMAKERS\n        ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { class: { active: ["clients"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/clientes" } }, [
              _c("img", { attrs: { src: "/static/menu-clients.svg" } }),
              _vm._v(" CLIENTES\n        ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              active:
                ["professionals", "professionals-edit"].indexOf(_vm.route) != -1
            }
          },
          [
            _c("router-link", { attrs: { to: "/profissionais" } }, [
              _c("img", { attrs: { src: "/static/menu-professionals.svg" } }),
              _vm._v(" PROFISSIONAIS\n        ")
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("CONTROLE")]),
      _vm._v(" "),
      _c("ul", [
        _c(
          "li",
          { class: { active: ["orders"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/pedidos" } }, [
              _c("img", { attrs: { src: "/static/menu-orders.svg" } }),
              _vm._v(" PEDIDOS\n        ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "inactive",
            class: { active: ["subscription"].indexOf(_vm.route) != -1 }
          },
          [_vm._m(2)]
        ),
        _vm._v(" "),
        _c(
          "li",
          { class: { active: ["cities"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/cidades" } }, [
              _c("img", { attrs: { src: "/static/menu-cities.svg" } }),
              _vm._v(" CIDADES\n        ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "inactive",
            class: { active: ["wallet-of-company"].indexOf(_vm.route) != -1 }
          },
          [_vm._m(3)]
        ),
        _vm._v(" "),
        _c(
          "li",
          { class: { active: ["transfers"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/transferencias" } }, [
              _c("a", [
                _c("img", { attrs: { src: "/static/menu-transfers.svg" } }),
                _vm._v(" TRANSFERÊNCIAS ")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { class: { active: ["coupons"].indexOf(_vm.route) != -1 } },
          [
            _c("router-link", { attrs: { to: "/cupons" } }, [
              _c("img", { attrs: { src: "/static/menu-coupons.svg" } }),
              _vm._v(" CUPONS\n        ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              active: ["professional-register-flow"].indexOf(_vm.route) != -1
            }
          },
          [
            _c("router-link", { attrs: { to: "/cadastro-profissionais" } }, [
              _c("img", {
                attrs: { src: "/static/menu-professional-register-flow.svg" }
              }),
              _vm._v(" CADASTRO\n          DE PROFISSINAIS\n        ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              active: ["professional-training-flow"].indexOf(_vm.route) != -1
            }
          },
          [
            _c("router-link", { attrs: { to: "/treinamento-profissionais" } }, [
              _c("img", { attrs: { src: "/static/menu-training.svg" } }),
              _vm._v("\n          TREINAMENTO PROFISSINAIS\n        ")
            ])
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "backdrop",
      on: {
        click: function($event) {
          return _vm.setOpened(!_vm.opened)
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("img", { attrs: { src: "/static/logo-branco.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("img", { attrs: { src: "/static/profile-outline.svg" } }),
      _vm._v(" perfil")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("img", { attrs: { src: "/static/menu-subscriptions.svg" } }),
      _vm._v(" ASSINATURAS ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("img", { attrs: { src: "/static/menu-wallet-of-company.svg" } }),
      _vm._v(" CARTEIRA DA EMPRESA\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d622f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d622f5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = null
// module chunks = 